
import { useGammaAuthenticator } from "@/composeable/gamma-authenticator";
import { AuthUIState } from "@/types/auth-ui";
import { PropType, defineComponent } from "vue";
export default defineComponent({
  props: {
    label: {
      required: true,
      type: String,
    },
    uiState: {
      required: true,
      type: Number as PropType<AuthUIState>,
    },
  },

  setup() {
    const { setUiState } = useGammaAuthenticator();

    return {
      setUiState,
    };
  },
});
